import * as xlsx from 'xlsx';

import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class ImportExcel {

  constructor() {}

  getFileName(name: string) {
    // TODO: remove timespan for the PR. it is handy for dev though
    let timeSpan = new Date().toISOString()
    let sheetName = name || 'ImportData'
    let fileName = `${sheetName}-${timeSpan}`
    return {
      sheetName,
      fileName,
    }
  }

  exportArrayToExcel(arr: any[], name: string, columnOrder: string[]) {
    let { sheetName, fileName } = this.getFileName(name);

    var wb = xlsx.utils.book_new();
    var ws = xlsx.utils.json_to_sheet(arr, { header: columnOrder });

    xlsx.utils.book_append_sheet(wb, ws, sheetName);
    xlsx.writeFile(wb, `${fileName}.xlsx`);
  }

  generate(config: any) {
    // headers
    let columnsToExport = this.getHeaders(config);

    let exportData = [];

    let x = new Object(); // row of friendly names
    let y = new Object(); // row of notes

      this.getFriendlyAndNote(config, x, y);

    exportData.push(x);
    exportData.push(y);

    this.exportArrayToExcel(exportData, config.defaultSpreadsheetName, columnsToExport)
  }

  getFriendlyAndNote(config: any, friendlyNames: Object, notes: Object) {
    config.columns.filter( c => !c.hidden)
     .forEach( i => {
        friendlyNames[i.databaseColumn] = i.friendlyName ?? i.databaseColumn;
        notes[i.databaseColumn] = i.notes ?? '';
    });

    config.subConfigs.forEach(sc => {
      this.getFriendlyAndNote(sc, friendlyNames, notes);
    });
  }

  getHeaders(config: any): string[] {
    let columnsToExport = config.columns.filter( c => !c.hidden)
        .map( i => i.hidden ? null : i.databaseColumn);

    if (config.subConfigs.length > 0) {
      config.subConfigs.forEach(sc => {
        columnsToExport = columnsToExport.concat(this.getHeaders(sc));
      });
    }
    return columnsToExport;
  }

}
